import React, { useRef, useState } from "react";
import { Button, Input, Checkbox } from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthLayout from "../AuthLayout";

const ResetPassword = ({ title, onSubmit, loading = false }) => {
  const [showPassword, setShowPassword] = useState(true);
  const [retypePassword, setRetypePassword] = useState(true);
  const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const togglePasswordVisibility = () => {
    setShowPassword(showPassword ? false : true);
  };

  const toggleRetypePasswordVisibility = () => {
    setRetypePassword(!retypePassword);
  };

  const passwordEl = useRef(null);
  const reTypePasswordEl = useRef(null);

  const formik = useFormik({
    initialValues: {
      password: "",
      reTypePassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Please enter your password.")
        .matches(passwordRegExp,
          "Minimum 8 characters, at least 1 uppercase, 1 lowercase, 1 number and 1 special character required"),
      reTypePassword: Yup.string()
        .required("Please enter your password.")
        .min(8, "Password is too short - should be 8 chars minimum."),
    }),
    onSubmit: (values) => {
      JSON.stringify(values, null, 2);
      onSubmit(values);
    },
  });
  return (
    <div className="initial-screen-content" style={{ minWidth: "420px" }}>
      <h1 className="content-title">{title}</h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="row gy-md-4 gy-3">
          <div className="col-12">
            <div id="show_hide_password" className="form-floating">
              <Input
                type={!showPassword ? " text" : "password"}
                id="password"
                placeholder="Password"
                label="Password"
                forr="password"
                inputRef={passwordEl}
                eyeVisibility={!showPassword ? "fa fa-eye" : "fa fa-eye-slash"}
                onClick={togglePasswordVisibility}
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="form-error-message">
                  {formik.errors.password}
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-12">
            <div id="show_hide_password" className="form-floating">
              <Input
                type={!retypePassword ? " text" : "password"}
                id="retype-password"
                placeholder="Retype Password"
                label="Confirm Password"
                forr="password"
                inputRef={reTypePasswordEl}
                eyeVisibility={
                  !reTypePasswordEl ? "fa fa-eye" : "fa fa-eye-slash"
                }
                onClick={toggleRetypePasswordVisibility}
                {...formik.getFieldProps("reTypePassword")}
              />
              {formik.touched.reTypePassword && formik.errors.reTypePassword ? (
                <div className="form-error-message">
                  {formik.errors.reTypePassword}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Button
          btnName="Submit"
          btnType="primary"
          type="submit"
          loading={loading}
        />
      </form>
    </div>
  );
};

export default AuthLayout()(ResetPassword);
